define('modules/files/file_list_item_view',[
  'backbone',
  'jquery',
  '_',
  'session',

  './file_model',
  'modules/video/player/video_player_view',
  'modules/item_image/image_player/image_player_view',

  'text!./file_list_item_template.html',
  'text!./file_list_upload_item_template.html'
], function (Backbone, $, _, session,
             FileModel,
             VideoView,
             ImagePlayerView,
             item_template,
             upload_template) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);
      this.period_id = opts.period_id;

      this.listenTo(this.model, 'change:uploading', function () {
        this.render();
      }, this);

      this.listenTo(this.model, 'change:progress', function () {
        this.showProgress();
      });

      this.listenTo(this.model, 'change:confirm-removal', function (model) {
        this.$('.js-remove-file')[model.get('confirm-removal') ? 'addClass' : 'removeClass']('confirm');
      }, this);

      this.render();
    },
    subViews: [],
    tagName: 'li',
    className: 'list-item',
    template: _.template(item_template),
    upload_template: _.template(upload_template),
    events: {
      'click .js-preview-media': 'previewMedia',
      'click .js-remove-file': 'removeFile'
    },

    render: function () {
      if (this.model.get('uploading')) {
        this.$el.html(this.upload_template(this.model.toJSON()));
      } else {
        this.$el.html(this.template(this.model.toJSON()));
      }
      return this;
    },

    showProgress: function () {
      this.$('.file-upload-progress span').css('width', this.model.get('progress') + '%');
    },

    previewMedia: function (e) {
      var media;

      e.preventDefault();

      if (session.has('current_preview')) {
        session.get('current_preview').close();
      }

      if (this.model.get('metadata').format === 'video') {
        media = new VideoView({model: this.model});
      } else {
        media = new ImagePlayerView({model: this.model});
      }

      session.set('current_preview', media);
      this.$el.addClass('is-active');
      this.$('.js-media-preview').html(media.$el).addClass('is-open');
    },

    removeFile: function (e) {
      e.preventDefault();
      var self = this;
      var t = setTimeout(function () {
        self.model.set('confirm-removal', false);
      }, 3000);

      if (this.model.get('confirm-removal')) {
        clearTimeout(t);
        this.model.destroy();
        this.$el.fadeOut(200);
        setTimeout(function () {
          self.remove();
        }, 200);

      } else {
        this.model.set('confirm-removal', true);
      }
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.remove();
      this.stopListening();
      return this;
    }

  });
  return View;
});

